import { CheckoutFormData } from "./types";
import { compileReservationData } from "./compileReservationData";
import { ReservationsEndpoint } from "../../../store/endpoints/reservation";
import { history } from "../../../App";
import {
  paymentStatusRoute,
  RESERVATION_UUID_QUERY_PARAM_NAME,
} from "../../../pages/PaymentStatus/route";
import { endSession } from "../../../store/shared/endSession";
import { resetOnBeforeUnload } from "../../../shared/beforeUnload";
import { validateCheckoutStep } from "../validate";
import { selectedPackagesApi } from "../../../store/selected/selectedPackages";
import { selectedActivitiesApi } from "../../../store/selected/selectedActivities";

export const onFinish = async (fd: CheckoutFormData): Promise<void> => {
  const validationResult = await validateCheckoutStep();
  if (!validationResult) return;

  const reservationData = await compileReservationData(fd);
  if (reservationData) {
    try {
      await selectedPackagesApi.cancelAllPackagesReserve();
      await selectedActivitiesApi.cancelAllActivitiesReserve();
    } catch (e) {
      console.log("Error while removing temporary time slots.");
    }

    const {
      data: { checkout_url, reservation_uuid },
    } = await ReservationsEndpoint.reserve.call(reservationData);
    if (checkout_url) {
      resetOnBeforeUnload();
      setTimeout(() => {
        window.location.href = checkout_url;
      }, 3000);
    } else {
      await endSession();
      history?.push(
        `${paymentStatusRoute.path}?${RESERVATION_UUID_QUERY_PARAM_NAME}=${reservation_uuid}`
      );
    }
  }
};
